import template from './sw-cms-block-acris-blog-title.html.twig';

const { Component } = Shopware;

Component.register('sw-cms-block-acris-blog-title', {
    template
});
